export function wrapMenuNormalList(type:any){
    return `<ul class="dropdown-menu megamenu" aria-labelledby="menu-${type.name.toLowerCase()}">
        <li class="row ml-0 mr-0">
            <div class="dropmenu ${type.name}">
            </div>
        </li>
    </ul>`
}